<template>
  <l-cache :get-data="getItem" :id="$route.query.id" ref="cache">
    <personPassGroupContent :data="data" slot-scope="{data}" @refresh="$refs.cache.retry()">
      <template slot="title-actions">
        <v-btn @click="$refs.cache.retry()" class="mx-0" color="primary" flat>刷新</v-btn>
      </template>
    </personPassGroupContent>
  </l-cache>
</template>
<script>

import personPassGroupContent from './personPassGroupContent'

export default {
  name: 'personPassGroupDetails',
  components: {personPassGroupContent},
  methods: {
    async getItem (key) {
      let {items} = await this.$store.dispatch('userAdmin/getPersonPassGroups', {
        pagination: {},
        search: {key: 'id', value: key}
      })
      console.log(items)
      if (items.length !== 0) {
        let item = items[0]
        item.obgrp.editInfo = false
        item.obgrp.loading = false
        return item.obgrp
      }
      else {
        this.$L.alert('error', '未找到该通行分组')
      }
    }
  }
}
</script>

<style scoped>

</style>
